
import { GameState } from '../GameContextTypes';
import { Skill } from '../../types/game';

export const addSkill = (state: GameState, skill: Skill): GameState => {
  // Check if user already has this skill
  if (state.skills.find(s => s.id === skill.id)) {
    return state;
  }
  
  const updatedAchievements = [...state.achievements, `Learned ${skill.name}`];
  const updatedKpis = { ...state.kpis };
  
  // Different skills affect different KPIs
  switch (skill.category) {
    case 'Technical':
      updatedKpis.efficiency = Math.min(100, updatedKpis.efficiency + 2);
      updatedKpis.uptime = Math.min(100, updatedKpis.uptime + 1);
      break;
    case 'Business':
      updatedKpis.profitMargin = Math.min(40, updatedKpis.profitMargin + 2);
      break;
    case 'Operations':
      // Fix: First calculate the new value, format it to 3 decimal places, then convert back to number
      const newEnergyCost = Math.max(0.001, updatedKpis.energyCost - 0.01);
      updatedKpis.energyCost = Number(newEnergyCost.toFixed(3));
      updatedKpis.efficiency = Math.min(100, updatedKpis.efficiency + 1);
      break;
    case 'Leadership':
      updatedKpis.profitMargin = Math.min(40, updatedKpis.profitMargin + 1);
      updatedKpis.uptime = Math.min(100, updatedKpis.uptime + 0.5);
      break;
  }
  
  return {
    ...state,
    skills: [...state.skills, skill],
    experience: state.experience + 20,
    achievements: updatedAchievements,
    kpis: updatedKpis
  };
};
